import { render, staticRenderFns } from "./generalPrint.vue?vue&type=template&id=c0b30a90&scoped=true&"
import script from "./generalPrint.vue?vue&type=script&lang=js&"
export * from "./generalPrint.vue?vue&type=script&lang=js&"
import style0 from "./generalPrint.vue?vue&type=style&index=0&id=c0b30a90&prod&scoped=true&lang=css&"
import style1 from "./generalPrint.vue?vue&type=style&index=1&id=c0b30a90&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b30a90",
  null
  
)

export default component.exports